import React from 'react'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'

const actionColors = {
    Created:  { bg: '#e8f8f0', color: '#1a9e5c', dot: '#1a9e5c' },
    Uploaded: { bg: '#e8f0fe', color: '#4f6ef7', dot: '#4f6ef7' },
    Updated:  { bg: '#fff7e6', color: '#d48806', dot: '#d48806' },
    Deleted:  { bg: '#fff0f0', color: '#e03131', dot: '#e03131' },
    Viewed:   { bg: '#f0f0ff', color: '#7c3aed', dot: '#7c3aed' },
}

const moduleColors = {
    'Staff':               { bg: '#eef2ff', color: '#4f6ef7' },
    'Videos':              { bg: '#f0fef9', color: '#1a9e5c' },
    'AI Generated':        { bg: '#fdf4ff', color: '#9333ea' },
    'Roles & Permissions': { bg: '#fff7e6', color: '#d48806' },
    'AI Chats':            { bg: '#e8f4fd', color: '#019CF1' },
}

const avatarColors = ['#8A34F8', '#019CF1', '#C234AD', '#00C9A7', '#FAA806', '#F76D3C']

const getInitials = (name) =>
    name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)

const labelStyle = { fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#999' }

const AuditTable = ({ data }) => {
    const navigate = useNavigate()

    if (!data?.length) {
        return (
            <div className="alert alert-success ps-4">No audit logs found!!</div>
        )
    }

    return (
        <div className='table-responsive'>
            <table className='jean-table table'>
                <tbody>
                    {data.map((log, i) => {
                        const action = actionColors[log.action] || { bg: '#f5f5f5', color: '#555', dot: '#999' }
                        const module = moduleColors[log.module] || { bg: '#f5f5f5', color: '#555' }
                        const avatarBg = avatarColors[i % avatarColors.length]
                        const performer = log.performedBy ?? {}
                        const displayName = performer.name || performer.username || 'Unknown'

                        return (
                            <tr key={log.id}>
                                <td>
                                    {performer.profilePicture ? (
                                        <img
                                            src={performer.profilePicture}
                                            alt={displayName}
                                            className="rounded-circle"
                                            style={{ width: 44, height: 44, objectFit: 'cover' }}
                                        />
                                    ) : (
                                        <div className="rounded-circle d-flex align-items-center justify-content-center"
                                            style={{ width: 44, height: 44, background: avatarBg, color: '#fff', fontWeight: 700, fontSize: 14 }}>
                                            {getInitials(displayName)}
                                        </div>
                                    )}
                                </td>

                                <td>
                                    <div>
                                        <p className='mb-0 fw-semibold' style={{ color: '#1a1a2e' }}>{displayName}</p>
                                        <p className='mb-0' style={{ fontSize: 12, color: '#999' }}>{performer.role}</p>
                                    </div>
                                </td>

                                <td>
                                    <div>
                                        <p className='mb-1' style={labelStyle}>Action</p>
                                        <span className="d-inline-flex align-items-center gap-1 px-2 py-1 rounded-pill fw-semibold"
                                            style={{ background: action.bg, color: action.color, fontSize: 12, whiteSpace: 'nowrap' }}>
                                            <span style={{ width: 6, height: 6, borderRadius: '50%', background: action.dot, display: 'inline-block', flexShrink: 0 }}></span>
                                            {log.action}
                                        </span>
                                    </div>
                                </td>

                                <td style={{ maxWidth: 300 }}>
                                    <div>
                                        <p className='mb-1' style={labelStyle}>Description</p>
                                        <p className='mb-0' style={{ color: '#444', lineHeight: 1.5 }}>{log.description}</p>
                                    </div>
                                </td>

                                <td>
                                    <div>
                                        <p className='mb-1' style={labelStyle}>Module</p>
                                        <span className="px-2 py-1 rounded-3 fw-semibold"
                                            style={{ background: module.bg, color: module.color, fontSize: 12, whiteSpace: 'nowrap' }}>
                                            {log.module}
                                        </span>
                                    </div>
                                </td>

                                <td>
                                    <div>
                                        <p className='mb-1' style={labelStyle}>Sub Module</p>
                                        {log.subModule ? (
                                            <span className="px-2 py-1 rounded-3"
                                                style={{ background: '#f5f5f5', color: '#666', fontSize: 12, whiteSpace: 'nowrap' }}>
                                                {log.subModule}
                                            </span>
                                        ) : (
                                            <span style={{ color: '#ccc', fontSize: 13 }}>—</span>
                                        )}
                                    </div>
                                </td>

                                <td>
                                    <div>
                                        <p className='mb-1' style={labelStyle}>Date</p>
                                        <p className='mb-0 fw-semibold' style={{ color: '#1a1a2e', whiteSpace: 'nowrap' }}>
                                            {moment(log.createdAt).format("DD MMM, YYYY")}
                                        </p>
                                    </div>
                                </td>

                                <td>
                                    <div>
                                        <p className='mb-1' style={labelStyle}>Details</p>
                                        <button
                                            onClick={() => {
                                                const logId = log.id || log._id || log.auditId
                                                navigate(`/audit/${logId}`, { state: { log } })
                                            }}
                                            title="View Details"
                                            style={{
                                                width: 36, height: 36, borderRadius: '50%',
                                                background: '#f0f0ff', border: 'none',
                                                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                                color: '#4f46e5', cursor: 'pointer'
                                            }}
                                        >
                                            <i className="bi bi-eye" style={{ fontSize: 16 }}></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default AuditTable
